import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-5" style={{backgroundColor: 'var(--bg-dark)', borderTop: '1px solid rgba(255,255,255,0.05)'}}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-4 text-center text-md-start mb-4 mb-md-0">
             <h5 className="brand-text text-white" style={{fontSize: '1.2rem'}}>NEVIS TRUST</h5>
             <p className="small text-muted mb-0">Established Fiduciary Excellence</p>
          </div>
          <div className="col-md-4 text-center mb-4 mb-md-0">
             <div className="d-flex justify-content-center gap-4">
                <Link to="/" className="text-muted text-decoration-none small text-uppercase letter-spacing-1">Home</Link>
                <Link to="/services" className="text-muted text-decoration-none small text-uppercase letter-spacing-1">Services</Link>
                <Link to="/contact" className="text-muted text-decoration-none small text-uppercase letter-spacing-1">Contact</Link>
             </div>
          </div>
          <div className="col-md-4 text-center text-md-end">
             <p className="small text-muted mb-0">
                &copy; {new Date().getFullYear()} Nevis Trust Services Limited.
             </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
